var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fd0f035c5e0df6d7c85dc043c7cb079b6a15fd48"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ecommerceberlin@eventjuicer"]={id:"fd0f035c5e0df6d7c85dc043c7cb079b6a15fd48"};
      